import get from 'lodash/get.js';

import ValidationErrors from '@/components/errors/ValidationErrors.vue';

export default {
    name: 'ValidationMixin',

    components: { ValidationErrors },

    data: () => ({
        validationErrors: null,
    }),

    methods: {
        scanValidationErrors(error) {
            this.validationErrors = get(error, 'response.data.errors');
        },
    },
};
